import SiteCard from "@/components/feature/SiteCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { getHotSites } from "@/utils/site";

export default function HotSites() {
  const hotSites = getHotSites(24);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          icon="ri-fire-line"
          title="精选热门网站"
          subtitle="根据访问量与时效精选的热门入口，鼠标悬停可查看网站介绍"
          action={{ label: "浏览更多分类", to: "/category/news" }}
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {hotSites.map((site) => (
            <SiteCard key={site.id} site={site} />
          ))}
        </div>
      </div>
    </section>
  );
}